import React from 'react'
import {Loading} from './components/Loading'
import {useDispatch, useSelector} from 'react-redux'
import {ConversationList} from './components/ConversationList'
import {NewConversationModal} from './components/NewConversationModal'
import {ManagedConversationsList} from './components/ManagedConversationsList'
import {NewManagedConversationModal} from './components/NewManagedConversationModa'
import {fetchMoreConversations} from '../../actions/conversations/fetchMoreConversations'
import {ClipLoader} from 'react-spinners'
import styled from "styled-components";
import {openSidePanelPopOver, closeSidePanelPopOver} from "../../dux/ui/actions";

export const SidePanel = ({
                            loading, conversations, onSetCurrentConversation,
                            currentConversation, recipients, loadingMoreConversations, canLoadMoreConversations,
                            popoverVisible
                          }) => {
  const dispatch = useDispatch()
  const [showNewConversationModal, setShowNewConversationModal] = React.useState(false)
  const [showNewManagedConversationModal, setShowNewManagedConversationModal] = React.useState(false)
  const [conversationOptions, setConversationOptions] = React.useState([])
  const [page, setPage] = React.useState(1);
  const {visible} = useSelector(state => state.ui.sidePanelPopOver)

  function fetchConversationOptions() {
    $.ajax({
      url: `/api/staff/v1/conversations/new_group_chat_options.json`,
      success: response => setConversationOptions(response)
    })
  }

  React.useEffect(() => {
    fetchConversationOptions()
  }, [])

  const handleOnScroll = (event) => {
    const target = event.target;
    if (target.scrollHeight - target.scrollTop === target.clientHeight
      && canLoadMoreConversations && !loadingMoreConversations) {
      dispatch(fetchMoreConversations(false, false, page + 1))
      setPage(page + 1);
    }
  }

  const actualComponent = (
    <>
      <NewManagedConversationModal
        conversationOptions={conversationOptions}
        show={showNewManagedConversationModal}
        handleClose={() => setShowNewManagedConversationModal(false)}/>
      <NewConversationModal
        recipients={recipients}
        show={showNewConversationModal}
        handleClose={() => setShowNewConversationModal(false)}/>
      <div className="w-100 h-100 d-flex flex-column pr-2">
        <div className="card-header d-flex justify-content-between">
          Conversations
          <div
            style={{fontSize: '12px'}}
            className="hoverable clickable bg-primary d-flex align-items-center pl-2 pr-2 pt-1 pb-1 cursor-default"
            onClick={() => setShowNewConversationModal(true)}>New</div>
        </div>
        <div className="h-100" style={{overflowY: 'scroll', overflowX: 'hidden', width: popoverVisible ? '100%' : 300 }} onScroll={handleOnScroll}>
          {
            loading ?
              <Loading/> :
              <>
                <ManagedConversationsList
                  conversationOptions={conversationOptions}
                  onShowNewManagedConversationModal={() => {
                    fetchConversationOptions()
                    setShowNewManagedConversationModal(true)
                  }}
                  currentConversation={currentConversation}
                  onSetCurrentConversation={onSetCurrentConversation}
                  conversations={conversations.filter(conversation => !!conversation.group_id)}/>
                <ConversationList
                  currentConversation={currentConversation}
                  onSetCurrentConversation={onSetCurrentConversation}
                  conversations={conversations.filter(conversation => !conversation.group_id)}/>
                {loadingMoreConversations && (
                  <div className="d-flex justify-content-center align-items-center">
                    <ClipLoader/>
                  </div>
                )}
              </>
          }
        </div>
      </div>
    </>
  )

  if (popoverVisible) {
    return <>
      {
        !visible && <FabButton
          style={{left: '16px'}}
          onClick={() => dispatch(openSidePanelPopOver())}>☰</FabButton>
      }
      <div id="side_panel"
           style={{padding: 0, display: visible ? "block" : "none"}}>
      {actualComponent}
      </div>
    </>
  }

  return actualComponent;
}

const PopOver = styled.div`
  position: fixed;
  bottom: 0;
  top: 0;
  left: 0;
  right: 0;
  padding-top: 55px;
  background-color: white;
  display: inline-block;
  z-index: 1000;
`

const FabButton = styled.a`
  background: #1d4ed8;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  text-align: center;
  color: #FFF !important;
  box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.2), 3px 3px 3px rgba(0, 0, 0, 0.21);
  position: fixed;
  bottom: 16px;
  font-size: 28px;
  display: inline-block;
  cursor: pointer;
  display: block;
  text-decoration: none !important;
`
